import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { dayToHour } from "../../../utils/dateConvert";
import { rounding } from "../../../utils/math";
import { downloadCSVFile } from "../../../api/apiClient";
import moment from "moment";
import ShowIButtonName from "../../commoncomponents/showIButtonName";

const isFeatureEnabled = (value) => value === true || value === "true" || value === 1 || value === "1";
const getSummaryRowClass = (report) => {
  if (Number(report.processed) === 0) {
    return "assetSummaryNoDataRow";
  }

  return report.allTrips == 0 ? "yellowBg" : "";
};

const openAssetSummaryReport = (href) => {
  const browserWindow = window.opener && !window.opener.closed ? window.opener : window;
  const reportWindow = browserWindow.open(href, "_blank");

  if (reportWindow) {
    reportWindow.focus();
    return;
  }

  window.open(href, "_blank");
};

function TotalSummary(props) {
  let customerName = props.customerName;
  let groupName = props.groupName;
  let timeZone = props.timeZone;

  const reports = props.reportDetails;
  const showTempA = reports.some((report) =>
    report.assetTempA !== undefined ? isFeatureEnabled(report.assetTempA) : report.tempA > 0
  );
  const showTempB = reports.some((report) =>
    report.assetTempB !== undefined ? isFeatureEnabled(report.assetTempB) : report.tempB > 0
  );
  const data = (
    <Table responsive striped>
      <thead>
        <tr className="nowwrapTH">
          <th>Asset</th>
          <th>Depot</th>
          <th>Timezone</th>
          <th>Start Date</th>
          <th style={{ width: "150px", minWidth: "150px", whiteSpace: "nowrap" }}>End Date</th>
          <th>Total Days</th>
          <th>Days in use</th>
          <th>Utilisation</th>
          <th>Trips</th>
          <th>Virtual Trips</th>
          <th>
            All Trips&nbsp;
            <i className="fa fa-info-circle text-primary" title="First Engine ON to Last Engine OFF"></i>
          </th>
          {/* <th>
            Duration&nbsp; <i className="fa fa-info-circle text-primary" title="First Engine ON to Last Engine OFF"></i>
          </th>
          <th>
            Duration Outside Depot&nbsp; <i className="fa fa-info-circle text-primary" title="First Departure until Last Entry or Engine OFF"></i>
          </th> */}
          <th>Engine Hours</th>
          <th>
            Moving Engine Hours&nbsp; <i className="fa fa-info-circle text-primary" title="Engine Hours - Virtual Parked"></i>
          </th>
          <th>Idling Hours</th>
          <th>
            Moving Engine Hours Outside&nbsp; <i className="fa fa-info-circle text-primary" title="Total moving engine hours outside depot"></i>
          </th>
          <th>Parked</th>
          <th>
            Total Parked &nbsp;
            <i className="fa fa-info-circle text-primary" title="Parked + Virtual Parked"></i>
          </th>
          <th>Distance</th>
          {/* <th>
            Average Journey&nbsp; <i className="fa fa-info-circle text-primary" title="Engine Hours / All Trips"></i>
          </th>
          <th>
            Average Parked &nbsp;
            <i className="fa fa-info-circle text-primary" title="Total Parked / All Trips"></i>
          </th>
          <th>
            Average Distance &nbsp;
            <i className="fa fa-info-circle text-primary" title="Distance / All Trips"></i>
          </th> */}
          <th>Parked Idle</th>
          <th>Duress</th>
          <th>Powercut</th>
          <th>Low Battery</th>
          {showTempA && <th>Temp A</th>}
          {showTempB && <th>Temp B</th>}
          <th>OverSpeed</th>
          <th>Harsh Accel</th>
          <th>Harsh Brake</th>
          <th>Harsh Corner</th>
          <th>OH&S</th>
          <th>GSM Loss</th>
          <th>GPS Loss</th>
          <th>Processed</th>
        </tr>
      </thead>
      <tbody>
        {reports.map((report, item) => {
          const assetSummaryHref = `/Rpt-summary?assetId=${report.assetId}&assetName=${report.asset}&SearchDate=${moment(report.startDate).format(
            "YYYY-MM-DD"
          )}&EndDate=${moment(report.endDate).format("YYYY-MM-DD")}`;

          return (
            <tr className={getSummaryRowClass(report)} key={report.assetId}>
              <td>
                {report.asset}
                <br />
                <ShowIButtonName ibuttonId={report.ibuttonId} serialno={report.serialno} iButtonName={report.iButtonName} />
              </td>
              <td>{report.depot}</td>
              <td>{report.timezone}</td>
              <td style={{ whiteSpace: "nowrap" }}>
                <button
                  type="button"
                  className="reportInlineLinkButton"
                  title={`View Asset Summary for ${report.asset}`}
                  onClick={() => openAssetSummaryReport(assetSummaryHref)}
                >
                  {moment(report.startDate).format("DD-MM-YYYY")}
                </button>
                {/* {utcToDDMMYYYY(report.dayTrips[0].dateTime)} */}
              </td>
              <td style={{ width: "100", minWidth: "100", whiteSpace: "nowrap" }}>{moment(report.endDate).format("DD-MM-YYYY")}</td>
              <td>{report.totalDays}</td>
              <td>{report.daysInUse}</td>
              <td>{report.utilisation}%</td>
              <td>{report.trips}</td>
              <td>{report.virtualTrips}</td>
              <td>{report.allTrips}</td>
              {/* <td>{dayToHour(report.duration)}</td>
              <td>{dayToHour(report.durationOutsideDepot)}</td> */}
              <td>{dayToHour(report.engineHours)}</td>
              <td>{dayToHour(report.movingEngineHours)}</td>
              <td>{dayToHour(report.idlingHours)}</td>
              <td>{dayToHour(report.movingEngineHoursOutside)}</td>
              <td>{dayToHour(report.parked)}</td>
              <td>{dayToHour(report.totalParked)}</td>
              <td>{report.distance}</td>
              {/* <td>{dayToHour(report.averageJourney)}</td>
              <td>{dayToHour(report.averageParked)}</td>
              <td>{rounding(report.averageDistance)}</td> */}
              <td>{report.parkedIdle}</td>
              <td>{report.duress}</td>
              <td>{report.powercut}</td>
              <td>{report.lowBattery}</td>
              {showTempA && <td>{report.tempA}</td>}
              {showTempB && <td>{report.tempB}</td>}
              <td>{report.speed}</td>
              <td>{report.harshAccel}</td>
              <td>{report.harshBrake}</td>
              <td>{report.harshCorner}</td>
              <td>{report.ohs}</td>
              <td>{report.gsmLoss}%</td>
              <td>{report.gpsLoss}%</td>
              <td>{report.processed}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );

  const handleDownloadExcel = () => {
    downloadCSVFile(props.reportDetails, "TotalSummary", `${customerName}_${groupName}`, timeZone);
  };

  return <ToggleBar caption="Total Summary" download={handleDownloadExcel} icon="fa-bar-chart" color="#337AB7" content={data} />;
}

export default TotalSummary;
